module.exports = __webpack_public_path__ + "static/company-notice-bg.6e50dfb1.png";


//////////////////
// WEBPACK FOOTER
// ./app/resource/page/index/views/images/company-notice-bg.png
// module id = 1004
// module chunks = 2